import { WretchError } from 'wretch/resolver'
import { ZodError } from 'zod'

import {
  ApiRequestErrorNetwork,
  ApiRequestErrorNetworkBackend,
  ApiRequestErrorOffline,
  ApiRequestErrorUnknown,
  ApiRequestErrorValidation,
} from './ApiRequestError'
import { dynamicErrorSchema } from './dynamicErrorSchema'

const parseApiRequestNetworkError = (error: WretchError) => {
  const result = dynamicErrorSchema.safeParse(error.json)
  if (result.success)
    throw new ApiRequestErrorNetworkBackend(error, result.data)
  throw new ApiRequestErrorNetwork(error)
}

// A failed fetch rejects with a TypeError (per the fetch spec); an aborted request rejects with a
// DOMException named 'AbortError'. Neither is a WretchError, so without this they'd be misreported
// as ApiRequestErrorUnknown ("Unknown error").
const isConnectivityError = (error: unknown): error is Error =>
  error instanceof TypeError ||
  (error instanceof Error && error.name === 'AbortError')

export const parseApiRequestError = (error: unknown) => {
  if (error instanceof ZodError) throw new ApiRequestErrorValidation(error)
  if (error instanceof WretchError) parseApiRequestNetworkError(error)
  if (isConnectivityError(error)) throw new ApiRequestErrorOffline(error)
  throw new ApiRequestErrorUnknown(error)
}
